import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from '@ts-core/lib/apollo';
import moment from 'moment';

import { formatValue } from '@ts-core/utils/dataTableUtils';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getStudentMediaItemStatsQuery } from 'modules/media/graphql/mediaStats/queries';

export default function useStudentMediaItemStats({ courseId, studentId, mediaId }) {
  const intl = useIntl();
  const {
    loading,
    error,
    data,
    refetch: onFetchStats,
  } = useQuery(getStudentMediaItemStatsQuery, {
    variables: { courseId, studentId, mediaId },
    skip: !courseId || !studentId || !mediaId,
    fetchPolicy: 'network-only',
  });
  const mediaStats = useMemo(() => data?.mediaStats || {}, [data]);

  const onGetXlsxData = useCallback(
    (sortedData) => {
      const header = [
        intl.formatMessage({ id: 'student.mediaItemStatsTable.startedAt' }),
        intl.formatMessage({ id: 'student.mediaItemStatsTable.lastEvent' }),
        intl.formatMessage({ id: 'student.mediaItemStatsTable.platform' }),
        intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
        intl.formatMessage({ id: 'student.mediaItemStatsTable.skipped' }),
      ];
      const dateFormat = 'DD/MM/YYYY HH:mm';

      const xlsxData = [header];

      sortedData.forEach((rowData) => {
        const { _original: mediaSession } = rowData;

        const mediaSessionData = [
          moment(mediaSession.createdAt).format(dateFormat),
          moment(mediaSession.lastEventDate).format(dateFormat),
          mediaSession.platform,
          formatValue(mediaSession.progressPercentage, 1),
          intl.formatMessage({
            id: mediaSession.skipProgress ? 'button.yes.title' : 'button.no.title',
          }),
        ];
        xlsxData.push(mediaSessionData);
      });

      return xlsxData;
    },
    [intl]
  );

  return {
    loading,
    error: getErrorMessage({ error }),
    mediaStats,
    onFetchStats,
    onGetXlsxData,
  };
}
